/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpHead_viewer = {
    readonly isPdpUrlTranslationEnabled?: boolean | null;
    readonly " $refType": "PdpHead_viewer";
};
export type PdpHead_viewer$data = PdpHead_viewer;
export type PdpHead_viewer$key = {
    readonly " $data"?: PdpHead_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpHead_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isPdpUrlTranslationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '212bdcefa3a647a7499cd65731f14454';
export default node;
